import { Tables } from '@/types/database.types';
import { CustomQueryOptions } from '@/types/query';
import { useQuery } from '@tanstack/react-query';
import { getLLMApiBilling } from '.';
import { GetLLMApiBillingParams } from './type';

const keyname = 'llm-api-billing';

export const useGetLLMApiBilling = (
  params: GetLLMApiBillingParams,
  option?: CustomQueryOptions<Tables<'llm_api_billing_history'>[]>
) => {
  return useQuery({
    queryKey: [[`${keyname}`, params], { params }],
    queryFn: async () => getLLMApiBilling(params),
    ...option,
  });
};
